import { __decorate } from "tslib";
import { DatasourceDefaults } from '@genesislcap/foundation-comms';
import { Connect } from '@genesislcap/foundation-comms';
import { attr, observable } from '@microsoft/fast-element';
import { FoundationElement } from '@microsoft/fast-foundation';
export class GridProBaseDatasource extends FoundationElement {
    constructor() {
        super(...arguments);
        this.isSnapshot = false;
        this.maxRows = DatasourceDefaults.MAX_ROWS_250;
        this.maxView = DatasourceDefaults.MAX_VIEW_1000;
        this.movingView = false;
        this.reverse = false;
    }
}
__decorate([
    Connect
], GridProBaseDatasource.prototype, "connect", void 0);
__decorate([
    observable
], GridProBaseDatasource.prototype, "deferredGridOptions", void 0);
__decorate([
    observable
], GridProBaseDatasource.prototype, "deferredColumnStates", void 0);
__decorate([
    attr
], GridProBaseDatasource.prototype, "criteria", void 0);
__decorate([
    attr
], GridProBaseDatasource.prototype, "fields", void 0);
__decorate([
    attr({ mode: 'boolean', attribute: 'is-snapshot' })
], GridProBaseDatasource.prototype, "isSnapshot", void 0);
__decorate([
    attr({ attribute: 'max-rows' })
], GridProBaseDatasource.prototype, "maxRows", void 0);
__decorate([
    attr({ attribute: 'max-view' })
], GridProBaseDatasource.prototype, "maxView", void 0);
__decorate([
    attr({ mode: 'boolean', attribute: 'moving-view' })
], GridProBaseDatasource.prototype, "movingView", void 0);
__decorate([
    attr({ attribute: 'order-by' })
], GridProBaseDatasource.prototype, "orderBy", void 0);
__decorate([
    attr({ attribute: 'resource-name' })
], GridProBaseDatasource.prototype, "resourceName", void 0);
__decorate([
    attr({ mode: 'boolean' })
], GridProBaseDatasource.prototype, "reverse", void 0);
